// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### 23-09-26 Komarov
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-01-22 Komarov
import { getPages } from '../../../Redux/actions';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../server/helpers/uniLog';

// ##### Komarov 2025-07-14
const ContentPages = (lang = localStorage.getItem('currentLanguage')) => {
  const dispatch = useDispatch();
  // ##### Komarov 2025-08-05
  const pages = useSelector(
    state => state.pagesRedux[state.language],
  );

  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (pages && pages.length > 0) {
      return;
    }
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/PageComponents/ContentPages.js:(getPages(lang))'
    );
    dispatch(getPages(lang));
    // ##### 23-04-12 Komarov
  }, [lang, pages, dispatch]);

  if (!pages) {
    return <div data-component="ContentPages"> Loading...</div>;
  }
  return pages;
};

export default ContentPages;
